module.exports = __webpack_public_path__ + "media/St 4-desk lamp-hint.2ab41da1.wav";